
class ByteUtils {

    public static formatBytes(bytes: number): string {
        if (bytes < 1024 * 1024) {
            return (bytes / 1024).toFixed(2) + " KB";
        } else if (bytes < 1024 * 1024 * 1024) {
            return (bytes / (1024 * 1024)).toFixed(2) + " MB";
        } else if (bytes < 1024 * 1024 * 1024 * 1024) {
            return (bytes / (1024 * 1024 * 1024)).toFixed(2) + " GB";
        }
    }

    public static bytesToGB(bytes: number): number {
        return bytes / (1024 * 1024 * 1024);
    }
}


export default ByteUtils;